/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Integration_QuestionInputs */

const en_faq_integration_question = /** @type {(inputs: Faq_Integration_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can you integrate AI into our existing business software?`)
};

const lv_faq_integration_question = /** @type {(inputs: Faq_Integration_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vai varat integrēt AI mūsu esošajā uzņēmuma programmatūrā?`)
};

/**
* | output |
* | --- |
* | "Can you integrate AI into our existing business software?" |
*
* @param {Faq_Integration_QuestionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const faq_integration_question = /** @type {((inputs?: Faq_Integration_QuestionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Integration_QuestionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_faq_integration_question(inputs)
	return en_faq_integration_question(inputs)
});